import { INDEX_DB } from "constants/general";
import Dexie, { Table } from "dexie";
import {
  MenopauseAssessmentDataType,
  OnboardingProgressData,
  OurConditionsConsentDataType,
  ProfileImageCacheType,
  UserConsentDataType,
} from "./db.types";

const db = new Dexie(INDEX_DB.DB_NAME) as Dexie & {
  [INDEX_DB.QUESTIONNAIRES_TABLE]: Table<MenopauseAssessmentDataType>;
  [INDEX_DB.CONSENTS_TABLE]: Table<UserConsentDataType>;
  [INDEX_DB.ONBOARDING_PROGRESS_TABLE]: Table<OnboardingProgressData>;
  [INDEX_DB.OUR_CONDITIONS_TABLE]: Table<OurConditionsConsentDataType>;
  [INDEX_DB.PROFILE_IMAGE_TABLE]: Table<ProfileImageCacheType>;
};

db.version(1).stores({
  [INDEX_DB.QUESTIONNAIRES_TABLE]: "++id, email",
  [INDEX_DB.CONSENTS_TABLE]: "++id, email, timestamp",
  [INDEX_DB.ONBOARDING_PROGRESS_TABLE]: "key",
  [INDEX_DB.OUR_CONDITIONS_TABLE]: "++id",
});

// Version 2: Add profile image cache table
db.version(2).stores({
  [INDEX_DB.QUESTIONNAIRES_TABLE]: "++id, email",
  [INDEX_DB.CONSENTS_TABLE]: "++id, email, timestamp",
  [INDEX_DB.ONBOARDING_PROGRESS_TABLE]: "key",
  [INDEX_DB.OUR_CONDITIONS_TABLE]: "++id",
  [INDEX_DB.PROFILE_IMAGE_TABLE]: "accountId",
});

export { db };
